/** Design steady state — see docs/PROCESS_MODELS.md §5.3. */
export const designPreset: Record<string, number> = {
  'P-101.RUN': 1,
  'P-303.RUN': 1,
  'FV-101.CMD': 66,
  'FV-202.CMD': 68,
  'FV-301.CMD': 64,
  'FV-303.CMD': 63,
  'FV-304.CMD': 61,
  'FV-305.CMD': 55,
  'FV-306.CMD': 55,
  'FV-307.CMD': 55,
  'TIC-201.OP': 52,
  'TIC-304.OP': 50,
};
